<template>
  <!--
    A fixed <span>, not a configurable tag: `atomic-boundaries` bans dynamic
    <component :is> composition inside atomic components, so an `as` prop
    cannot be honoured. A span is valid wherever hidden text is needed.
  -->
  <span :class="[structure['root'], focusable ? structure['focusable'] : '']">
    <slot />
  </span>
</template>

<script setup lang="ts">
import structure from './VisuallyHidden.structure.module.css'

withDefaults(
  defineProps<{
    /** Reveals the content while focus is inside it, as a skip link does. */
    focusable?: boolean
  }>(),
  { focusable: false }
)

defineSlots<{
  /** Text announced by assistive technology but not painted on screen. */
  default?: () => unknown
}>()
</script>
